





































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import SatusehatMonitorSvc from "@/services/SatusehatMonitor";
import { userModule } from "@/store/modules/user";
import {
  SATUSEHAT_ALASAN,
  SATUSEHAT_HASIL_KIRIM_ULANG,
  SATUSEHAT_JENIS_KIRIM_ULANG,
  SATUSEHAT_PEMERIKSAAN,
  SATUSEHAT_SEBAB_KIRIM_ULANG,
  SATUSEHAT_STATUS,
  SatusehatAktivitas,
  SatusehatAlasan,
  SatusehatHasilKirimUlang,
  SatusehatJenisKirimUlang,
  SatusehatKirimUlangResponse,
  SatusehatKunjunganResponse,
  SatusehatKunjunganRow,
  SatusehatObatRow,
  SatusehatPemeriksaanKey,
  SatusehatStatus,
  SatusehatStatusTampilan,
  SatusehatTrenRow,
  SatusehatUnit
} from "@/types/satusehat_monitor";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

const REFRESH_MS = 300000;

const JENIS_KIRIM_ULANG: SatusehatJenisKirimUlang[] = ["kunjungan", "obat"];

interface SatusehatKonfirmasiKirim {
  item: SatusehatKunjunganRow;
  jenis: SatusehatJenisKirimUlang;
}

interface SatusehatTile {
  key: string;
  status: SatusehatStatus | null;
  label: string;
  value: number;
  color: string;
  icon: string;
}

@Component({ components: { VCDateTimePicker } })
export default class SatusehatMonitorPage extends Vue {
  readonly HARI_TREN = 14;

  readonly JEDA_MENIT = 5;

  tgl = moment().subtract(1, "day").format("YYYY-MM-DD");
  unit: string | null = null;
  cari = "";
  statusFilter: SatusehatStatus | null = null;
  tab = 0;

  aktivitas: SatusehatAktivitas | null = null;
  tren: SatusehatTrenRow[] = [];
  daftarUnit: SatusehatUnit[] = [];
  kunjunganData: SatusehatKunjunganResponse | null = null;

  loadingRingkasan = false;
  loadingKunjungan = false;
  galat: string | null = null;
  diperbarui: string | null = null;
  autoRefresh = true;

  dialogKirim = false;
  konfirmasi: SatusehatKonfirmasiKirim | null = null;
  mengirim: string | null = null;
  hasilKirim: SatusehatKirimUlangResponse | null = null;

  private timer: number | null = null;
  private permintaanKunjungan = 0;

  readonly hariIni = moment().endOf("day").toDate();

  get bolehKirimUlang(): boolean {
    return userModule.hasPrivilege("satusehat_monitor", "resend");
  }

  get headersKunjungan() {
    const headers = [
      { text: "Register", value: "register", width: "110px" },
      { text: "Pasien", value: "nama_pasien" },
      { text: "Unit / DPJP", value: "unit", sortable: false },
      { text: "Status", value: "status", width: "150px" },
      { text: "Keterangan", value: "keterangan", sortable: false },
      { text: "Obat", value: "obat", sortable: false, width: "100px" }
    ];

    return this.bolehKirimUlang
      ? [...headers, { text: "Kirim ulang", value: "aksi", sortable: false, width: "96px", align: "center" }]
      : headers;
  }

  readonly headersObat = [
    { text: "Register / Pasien", value: "register" },
    { text: "Resource", value: "jenis" },
    { text: "Status", value: "terkirim", width: "100px" },
    { text: "ID IHS / Galat", value: "keterangan", sortable: false },
    { text: "Waktu", value: "waktu", width: "140px" }
  ];

  get tglDate(): Date | null {
    return composeDate(this.tgl);
  }
  set tglDate(val: Date | null) {
    this.tgl = toDateString(val) || this.tgl;
  }

  get units(): Array<SatusehatUnit & { label: string }> {
    return this.daftarUnit.map(u => ({ ...u, label: `${u.kode} — ${u.nama}` }));
  }

  get rowsTampil(): SatusehatKunjunganRow[] {
    const rows = this.kunjunganData?.rows || [];

    return this.statusFilter ? rows.filter(r => r.status === this.statusFilter) : rows;
  }

  get obatTampil(): SatusehatObatRow[] {
    return this.kunjunganData?.obat || [];
  }

  get tiles(): SatusehatTile[] {
    const r = this.kunjunganData?.ringkasan;
    if (!r) return [];

    const statuses: SatusehatStatus[] = ["terkirim", "gagal", "tidak_dikirim", "menunggu"];

    return [
      {
        key: "total",
        status: null,
        label: "Kunjungan",
        value: r.total,
        color: "grey darken-2",
        icon: "mdi-account-multiple-outline"
      },
      ...statuses.map(s => ({
        key: s,
        status: s,
        label: SATUSEHAT_STATUS[s].label,
        value: r[s],
        color: SATUSEHAT_STATUS[s].color,
        icon: SATUSEHAT_STATUS[s].icon
      }))
    ];
  }

  get pemeriksaanTerlewat(): string[] {
    const data = this.kunjunganData;
    if (!data || data.ringkasan.tidak_dikirim + data.ringkasan.menunggu === 0) return [];
    const p = data.pemeriksaan;

    return (Object.keys(p) as SatusehatPemeriksaanKey[])
      .filter(k => !p[k])
      .map(k => SATUSEHAT_PEMERIKSAAN[k]);
  }

  @Watch("tgl")
  @Watch("unit")
  onFilterChanged() {
    this.statusFilter = null;
    this.loadKunjungan();
  }

  @Watch("autoRefresh")
  onAutoRefreshChanged(val: boolean) {
    if (val) {
      this.refresh();
    }
  }

  mounted() {
    this.refresh();
    this.timer = window.setInterval(() => {
      if (this.autoRefresh) {
        this.refresh();
      }
    }, REFRESH_MS);
  }

  beforeDestroy() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  async refresh() {
    this.galat = null;
    await Promise.all([this.loadRingkasan(), this.loadKunjungan()]);
    if (!this.galat) {
      this.diperbarui = moment().format("HH:mm");
    }
  }

  async loadRingkasan() {
    this.loadingRingkasan = true;
    try {
      const res = await SatusehatMonitorSvc.ringkasan(this.HARI_TREN);
      this.aktivitas = res.aktivitas;
      this.tren = res.tren || [];
      this.daftarUnit = res.units || [];
    } catch (e) {
      this.tanganiGalat(e);
    } finally {
      this.loadingRingkasan = false;
    }
  }

  async loadKunjungan() {
    const nomor = ++this.permintaanKunjungan;
    this.loadingKunjungan = true;
    try {
      const res = await SatusehatMonitorSvc.kunjungan(this.tgl, this.unit);
      if (nomor === this.permintaanKunjungan) {
        this.kunjunganData = res;
      }
    } catch (e) {
      if (nomor === this.permintaanKunjungan) {
        this.kunjunganData = null;
        this.tanganiGalat(e);
      }
    } finally {
      if (nomor === this.permintaanKunjungan) {
        this.loadingKunjungan = false;
      }
    }
  }

  tanganiGalat(e: { response?: { data?: { message?: string } } }) {
    this.galat =
      e?.response?.data?.message ||
      "Data monitoring SATUSEHAT gagal dimuat. Coba muat ulang beberapa saat lagi.";
    this.autoRefresh = false;
  }

  jenisTampil(item: SatusehatKunjunganRow): SatusehatJenisKirimUlang[] {
    return JENIS_KIRIM_ULANG.filter(j =>
      j === "kunjungan"
        ? item.status === "gagal" || item.status === "tidak_dikirim"
        : item.obat.gagal > 0
    );
  }

  kunciKirim(item: SatusehatKunjunganRow, jenis: SatusehatJenisKirimUlang): string {
    return `${item.register}:${jenis}`;
  }

  tooltipKirimUlang(item: SatusehatKunjunganRow, jenis: SatusehatJenisKirimUlang): string {
    const kelayakan = item.kirim_ulang[jenis];

    if (kelayakan.boleh) {
      return `Kirim ulang ${this.labelJenis(jenis)} ke SATUSEHAT`;
    }

    if (!kelayakan.sebab) {
      return "Tidak dapat dikirim ulang.";
    }

    const sebab = SATUSEHAT_SEBAB_KIRIM_ULANG[kelayakan.sebab];

    return kelayakan.sebab === "data_belum_lengkap"
      ? `${sebab} ${item.hambatan.map(a => this.labelAlasan(a)).join(", ")}.`
      : sebab;
  }

  mintaKirimUlang(item: SatusehatKunjunganRow, jenis: SatusehatJenisKirimUlang) {
    if (!item.kirim_ulang[jenis].boleh || this.mengirim !== null) return;

    this.konfirmasi = { item, jenis };
    this.dialogKirim = true;
  }

  tutupKonfirmasi() {
    this.dialogKirim = false;
    this.konfirmasi = null;
  }

  async kirimUlang() {
    const konfirmasi = this.konfirmasi;
    if (!konfirmasi || this.mengirim !== null) return;

    this.tutupKonfirmasi();
    this.mengirim = this.kunciKirim(konfirmasi.item, konfirmasi.jenis);
    this.hasilKirim = null;

    try {
      this.hasilKirim = await SatusehatMonitorSvc.kirimUlang(konfirmasi.item.register, konfirmasi.jenis);
    } catch (e) {
      this.hasilKirim = null;
    } finally {
      this.mengirim = null;
    }

    await this.refresh();
  }

  labelJenis(jenis: SatusehatJenisKirimUlang): string {
    return SATUSEHAT_JENIS_KIRIM_ULANG[jenis];
  }

  tipeHasil(hasil: SatusehatHasilKirimUlang): string {
    return SATUSEHAT_HASIL_KIRIM_ULANG[hasil];
  }

  tanggalPanjang(val: string): string {
    return moment(val, "YYYY-MM-DD").format("DD-MM-YYYY");
  }

  statusTampil(status: SatusehatStatus): SatusehatStatusTampilan {
    return SATUSEHAT_STATUS[status];
  }

  labelAlasan(kode: SatusehatAlasan): string {
    return SATUSEHAT_ALASAN[kode] || kode;
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  tanggalPendek(val: string): string {
    return moment(val, "YYYY-MM-DD").format("ddd, DD MMM");
  }

  angka(val: number): string {
    return new Intl.NumberFormat("id-ID").format(val || 0);
  }

  angkaAtauStrip(val: number | null): string {
    return val === null ? "-" : this.angka(val);
  }
}
